import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Checkbox } from 'antd';
import { CriteriaList } from '../../../../shared/criteria-list/criteria-list';
import { LogsType } from '@src/utils/enums';
import { LogCriteria } from '@src/dtos/search-criteria.dto';
import { trafficFilteringCriteriaConfig } from '../traffic-filtering-criteria-config';
import { urlFilteringCriteriaConfig } from '../url-filtering-criteria-config';
import { getThreatFilteringCriteriaConfig } from '../threat-filtering-criteria-config';
import { FwVersion } from 'src/dtos/version.dto';

interface LogTypeCriteriaProps {
    logType: LogsType;
    isChecked: boolean;
    toggleIsChecked: () => void;
    validationErrors: Map<string, string>;
    searchCriteriaDto: LogCriteria;
    setSearchCriteria: (searchCriteria: LogCriteria, type: LogsType) => void;
    activeVersion: FwVersion | undefined;
    isAdvanced?: boolean;
}

export const LogTypeCriteria: React.FC<LogTypeCriteriaProps> =
    observer(({ logType, isChecked, toggleIsChecked, validationErrors, searchCriteriaDto, activeVersion, setSearchCriteria, isAdvanced }) => {

        const criteriaConfig = useMemo(() => {
            switch (logType) {
                case LogsType.TRAFFIC:
                    return trafficFilteringCriteriaConfig(activeVersion);
                case LogsType.URL_FILTERING:
                    return urlFilteringCriteriaConfig;
                case LogsType.THREAT:
                    return getThreatFilteringCriteriaConfig(isAdvanced);
            }
        }, [logType, activeVersion]);

        const setSelfSearchCriteria = (searchCriteria: LogCriteria) => {
            setSearchCriteria(searchCriteria, logType);
        };

        return (
            <div className="criteria-wrapper" key={logType}>
                <div className="title flex">
                    <Checkbox checked={isChecked}
                        onChange={toggleIsChecked} />
                    <div>{logType}</div>
                </div>
                {isChecked &&
                    <CriteriaList criteriaConfig={criteriaConfig} validationErrors={validationErrors}
                        searchCriteria={searchCriteriaDto}
                        changeSearchCriteria={setSelfSearchCriteria}
                        />}
            </div>
        );
    });